import { useRouter } from 'next/router';
import { useState } from 'react';
import { images } from '../../../Constants/ImageUrls';
import { getRouterLocale } from '../../../Utils/i18Utils/constant';
import { clicked_cta_event } from '../../../Utils/questionUtils';
import { getSearchParams } from '../../Parenting/common';
import AnchorCoverTag from '../../StoreHomePage/AnchorCoverTag';
import {
  BreadCrumbsArrow,
  BreadcrumbsHeading,
  BreadcrumbsList,
  CategoryBreadcrumbs,
} from './styled';

export default function Breadcrumbs(props) {
  const { breadCrumbs, addClass, postData, noPad, location } = props;
  const router = useRouter();
  const [cardEffect, setCardEffect] = useState({ index: '', effect: '' });
  const callbackFunction = (index, deeplinkValue, element) => {
    setCardEffect({ index: index, effect: 'lowOpacity' });
    clicked_cta_event(
      null,
      element?.name,
      'breadcrumbs',
      deeplinkValue,
      'breadcrumbs',
      postData?.content_id,
      postData?.object_id,
    );
    setTimeout(() => {
      router.push(`${deeplinkValue}` + getSearchParams(), '', {
        locale: getRouterLocale(router),
      });
    }, [200]);
  };
  const getSplitUrl = (url) => {
    return url.split('https://mylofamily.com').pop() || '/';
  };
  return (
    <CategoryBreadcrumbs
      className={addClass ? 'addClass' : ''}
      noPad={noPad}
      location={location}
    >
      <ul>
        {breadCrumbs?.map((element, index) => {
          const splitLink = element?.deeplinkValue
            ? getSplitUrl(element?.deeplinkValue)
            : null;
          const currentEqualToHighlight = cardEffect.index == index;
          return (
            <BreadcrumbsList
              className={element?.deeplinkValue ? `greenColor ` : ``}
              key={`breadcrumbs${index}`}
            >
              <BreadcrumbsHeading>
              <AnchorCoverTag
                url={splitLink}
                cardEffect={currentEqualToHighlight ? cardEffect?.effect : ''}
                callbackFunction={callbackFunction}
                index={index}
                element={element}
              >
                {element?.name}{' '}
                <BreadCrumbsArrow
                  loading="lazy"
                  src={images.arrowdownforward}
                  alt="arrow"
                  className={breadCrumbs.length - 1 == index ? 'hideArrow' : ''}
                />
              </AnchorCoverTag>
              </BreadcrumbsHeading>
            </BreadcrumbsList>
          );
        })}
      </ul>
    </CategoryBreadcrumbs>
  );
}
